import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function CategoryMixCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.mgmtCategoryMixChart !== 'undefined') {
      window.mgmtCategoryMixChart.canvas = chartRef.current;
      window.mgmtCategoryMixChart.ctx = chartRef.current.getContext('2d');
      document.getElementById('mgmtCategoryMix').chart = window.mgmtCategoryMixChart;
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title" id="mgmtMixTitle">Category Mix — all years</h3>
        <span className="click-tag">Click bars for details</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="mgmtCategoryMix" ref={chartRef}></canvas>
      </div>
    </Box>
  );
}
